import { Permissions } from 'constants/permissions';
import { useAccessControl } from 'hooks/access-control';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Alert from 'components/Alert/Alert';

import { selectPermissions } from 'api/user-permissions-slice';

export const AlreadyImportedAlert = ({ result, onForce, onClose }) => {
  const { t } = useTranslation();
  const permissions = useSelector(selectPermissions);
  const hasAccess = useAccessControl(permissions);
  const completed = ['completed', 'completed_with_errors'].includes(result?.bulk_action_status);
  const canForce = hasAccess(Permissions.CompanyWrite) && completed && !result?.resumed;
  const title = result?.resumed
    ? t('bulkImport.retryingTitle')
    : t('bulkImport.alreadyImportedTitle');
  let message = t('bulkImport.alreadyImportedProcessing');
  if (result?.resumed) {
    message = t('bulkImport.retryingMessage');
  } else if (completed) {
    message = t('bulkImport.alreadyImportedCompleted');
  }

  return (
    <Alert
      show={Boolean(result)}
      title={title}
      message={message}
      ok={canForce ? t('bulkImport.importAnyway') : t('bulkImport.close')}
      cancel={canForce ? t('bulkImport.close') : undefined}
      type="warning"
      onOk={canForce ? onForce : onClose}
      onCancel={onClose}
    />
  );
};
